export default __webpack_public_path__ + "static/media/loader.69e9de9c.gif";